module.exports = __webpack_public_path__ + "static/media/logo-light.063f0acd.png";